export const COLORS = {
    text: {
      light: '#333333', // white
      dark: '#d7d7d7', // near-black
    },
    textInvert: {
      light: 'white',
      dark: 'black'
    },
    textHeaders: {
      light: '#37698f', // white
      dark: '#C8D98D', // near-black
    },
    textHigilight: {
      light: '#6495ba', // white
      dark: '#24bfb0', // near-black
    },
    textBright: {
      light: 'black', // white
      dark: 'white', // near-black
    },
    textInv: {
      light: 'white', // white
      dark: 'white', // near-black
    },
    background: {
      light: 'hsl(0deg, 0%, 100%)', // white
      dark: '#292929', // navy navy blue
    },
    primary: {
      light: 'hsl(340deg, 100%, 40%)', // Pinkish-red
      dark: 'hsl(50deg, 100%, 50%)', // Yellow
    },
    secondaryy: {
      light: '#9987ef', // Purplish-blue
      dark: '#00aacc', // Cyan
    },
    svg:{
      light:'#83abcac7',
      dark:'white',
    },
    svgBackgroundBlob:{
      light:'#83abcac7',
      dark:'#e6e6e64a',
    },
    // Grays, scaling from least-noticeable to most-noticeable
    gray300: {
      light: 'hsl(0deg, 0%, 70%)',
      dark: 'hsl(0deg, 0%, 30%)',
    },
    gray500: {
      light: 'hsl(0deg, 0%, 50%)',
      dark: 'hsl(0deg, 0%, 50%)',
    },
    gray700: {
      light: 'hsl(0deg, 0%, 30%)',
      dark: 'hsl(0deg, 0%, 70%)',
    },
    eleYellow:{
      light:'#fffca985',
      dark: '#131a1fab',
    },
    eleBlue:{
      light:'#bbd9f1ab',
      dark:'#131a1fab'
    },
    eleDarkBlue:{
      light:'#00507A',
      dark:'#131a1fab'
    },
    bgpills:{
      light:'#37698f',
      dark:'#3c7a62'
    },    
    bgpillsSec:{
      light:'#192b37',
      dark:'#4f4f4f'
    },    
    selection:{
      light:'#457b9482',
      dark:'#cafdff73'
    },
    blocks:{
      light:'#e9eff6d1',
      dark:'#1c1c1c'
    },
    blocksHover:{
      light:'#30455f',
      dark:'#131313'
    },
    footer:{
      light:'#e9eff691',
      dark:'#1c1c1c'
    },
    imgBackground:{
      light:'#b7deff',
      dark:'#686868'
    },
    headerHighlightStart:{
      light:'#87c1ed',
      dark:'#597008'
    },
    headerHighlightEnd:{
      light:'#1095fa',
      dark:'#849b34'
    },
    techSkillsBg:{
      light:'#37698f',
      dark:'#1c1c1c'
    }
    
  };
  
  export const COLOR_MODE_KEY = 'color-mode';
  export const INITIAL_COLOR_MODE_CSS_PROP = '--initial-color-mode';